import React from "react";
/* 【2026-10-29 时区口径统一】文件上传 / 生成日期属设计部显示层，固定洛杉矶口径。
   本组件由主线 2026-10-29 新增时用的是 lib/date（浏览器本机时区），
   合并到本分支后与设计部「全部统一按美国时间」的口径冲突 ——
   同一份上传时间，中国同事和美国同事会看到不同日期。改走 usDate。 */
import { fmtDT } from "../../../lib/usDate";
import { T } from "../../../lib/i18n";

export const isValidUploadDate = (value) => {
  if (typeof value !== "string" || !value.trim()) return false;
  const raw = value.trim();
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?)?$/);
  if (!match) return false;
  const [, ys, ms, ds] = match;
  const year = Number(ys), month = Number(ms), day = Number(ds);
  const calendar = new Date(Date.UTC(year, month - 1, day));
  if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return false;
  return Number.isFinite(Date.parse(raw));
};

export const uploadDateLabel = (value, fallbackValue, dateKind = "upload") => {
  const dateValue = isValidUploadDate(value) ? value : (isValidUploadDate(fallbackValue) ? fallbackValue : null);
  const generated = dateKind === "generated";
  const label = generated ? "生成日期：{0}" : "上传日期：{0}";
  const empty = generated ? "暂无生成日期" : "暂无上传日期";
  return T(label, [dateValue ? fmtDT(dateValue) : T(empty)]);
};

/** Render a per-file upload/generation timestamp; callers must not pass message or batch event times. */
export default function FileUploadDate({ value, fallbackValue, dateKind = "upload", className = "" }) {
  return (
    <span className={`text-[10px] text-slate-500 ${className}`.trim()} data-testid="file-upload-date">
      {uploadDateLabel(value, fallbackValue, dateKind)}
    </span>
  );
}
